module.exports = __webpack_public_path__ + "img/layout-5.ff67e7da.jpg";